export default __webpack_public_path__ + "static/media/login-lock.40382d5a.svg";